import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@tanium/react-button';

// The menu's trigger. It offers no payment options, so it is disabled.
export const AddPaymentMethodMenu: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <Button size="sm" disabled>
      {t('Add Payment Method')}
    </Button>
  );
};
